import React, { useState, useCallback, useMemo } from 'react';

import {
  Progress,
  Box,
  ButtonGroup,
  Button,
  Heading,
  Flex,
  FormControl,
  GridItem,
  FormLabel,
  Input,
  Select,
  SimpleGrid,
  InputLeftAddon,
  InputGroup,
  Textarea,
  FormHelperText,
  InputRightElement,
  VStack,
} from '@chakra-ui/react';

import { HStack, Stack, Text, useColorModeValue} from '@chakra-ui/react';
import { Card, CardHeader, CardBody, CardFooter } from '@chakra-ui/react';

import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';

import { useToast } from '@chakra-ui/react';
import FileUp from './FileUp.tsx';


import { DatePicker } from 'antd';
import { Link } from "react-router-dom";

import axios from 'axios';

export default function RsopForm() {
  const [showPassword, setShowPassword] = useState(false);
  const [show, setShow] = React.useState(false);
  const [sop, setSop] = useState("");
  const [price, setPrice] = useState("");
  const [payStatus, setPayStatus] = useState("");
  const formData = {
    sop : sop,
    price : 599,
    paymentStatus: true,
  }
  const token = localStorage.getItem("token")
  const handleClick = async () => {
    await axios.get('https://glb-api.onrender.com/sop/review',{params:{formData:formData,
  token:token}})
    .then(res => console.log("submitted"))
    .catch(err => console.log(err))
  };
  return (
    <>
      <Flex
        minH={'100vh'}
        align={'center'}
        justify={'center'}
        bg={useColorModeValue('gray.50', 'gray.800')}
      >
        <Stack spacing={8} mx={'auto'} minW={'70%'} py={12} px={6}>
          <Stack align={'center'}>
            <Heading fontSize={'4xl'} textAlign={'center'}>
              SOP Review
            </Heading>
            <Text fontSize={'lg'} color={'gray.600'}>
              Fill up this form to get your SOP reviewed 📃
            </Text>
          </Stack>
          <Box
            rounded={'lg'}
            bg={useColorModeValue('white', 'gray.700')}
            boxShadow={'lg'}
            p={8}
          >
            <Stack spacing={4}>
              <HStack>
                <Card variant={'filled'} width={'100%'}>
                  <CardHeader>
                    <Heading size="md"> SOP Format: </Heading>
                  </CardHeader>
                  <CardBody>
                    <Select placeholder="Select option">
                      <option value="option1">Option 1</option>
                      <option value="option2">Option 2</option>
                      <option value="option3">Option 3</option>
                    </Select>
                  </CardBody>
                </Card>
                <Card variant={'filled'} width={'100%'}>
                  <CardHeader>
                    <Heading size="md"> SOP Language</Heading>
                  </CardHeader>
                  <CardBody>
                    <Select placeholder="Select option">
                      <option value="option1">Option 1</option>
                      <option value="option2">Option 2</option>
                      <option value="option3">Option 3</option>
                    </Select>
                  </CardBody>
                </Card>
              </HStack>

              <HStack>
                <Card variant={'filled'} width={'100%'}>
                  <CardHeader>
                    <Heading size="md"> Select Country </Heading>
                  </CardHeader>
                  <CardBody>
                    <VStack spacing={5}>
                    <Select placeholder="Select Country">
                      <option value="option1">Option 1</option>
                      <option value="option2">Option 2</option>
                      <option value="option3">Option 3</option>
                    </Select>

                    <Select placeholder="Select State">
                      <option value="option1">Option 1</option>
                      <option value="option2">Option 2</option>
                      <option value="option3">Option 3</option>
                    </Select>
                    </VStack>

                  </CardBody>
                </Card>
                <Card variant={'filled'} width={'100%'}>
                  <CardHeader>
                    <Heading size="md"> SOP Deadline</Heading>
                  </CardHeader>
                  <CardBody>
                  <DatePicker size={'large'} style={{ width: '100%' }}  onChange={(date) => console.log(date)} />
                  </CardBody>
                </Card>
              </HStack>
              <FormControl id="email" isRequired>
                <FormLabel>Email address</FormLabel>
                <Input type="email" />
              </FormControl>

              <Card padding={5}>
                <CardHeader>
                  <Heading size="md"> Upload your SOP here</Heading>
                </CardHeader>
                <FileUp />
                <CardBody marginTop={10}>
                  <FormControl isRequired>
                    <FormLabel>Instructions</FormLabel>

                    <Textarea
                      name="message"
                      placeholder="Type your instructions here"
                      rows={6}
                      resize="none"
                      value={sop}
                      onChange={(e)=>setSop(e.target.value)}
                    />
                  </FormControl>
                </CardBody>
              </Card>


              <Stack spacing={10} pt={2}>
                <Box >
                <Link to="/OrderSummary" >
                <Button
                  width={'100%'}
                  loadingText="Submitting"
                  size="lg"
                  bg={'blue.400'}
                  color={'white'}
                  _hover={{
                    bg: 'blue.500',
                  }}
                  onClick={handleClick}
                >
                  Proceed
                </Button>
                </Link>
                </Box>

              </Stack>
            </Stack>
          </Box>
        </Stack>
      </Flex>
    </>
  );
}
